import helpers from './helpers.js'

/*
===========================================
Clickable blocks
===========================================
*/
export default (function () {
  return {
    init() {
      const clickable = document.querySelectorAll('.js-clickable');

      if (!clickable.length || helpers.isEditMode()) return;

      document.body.addEventListener('click', (e) => {
        if (e.target.matches('.js-clickable') || e.target.closest('.js-clickable')) {
          if (!e.target.matches('.js-clickable-exclude') && e.target.closest('.js-clickable-exclude') === null) {
            e.preventDefault();
            if (e.target.matches('.no-focus') || e.target.closest('.no-focus') !== null) {
              return;
            }

            const el = e.target.matches('.js-clickable') ? e.target : e.target.closest('.js-clickable');
            const link = el.querySelector('.js-clickable-target') !== null ? el.querySelector('.js-clickable-target') : el.querySelector('a');
            const url = link.getAttribute('href');
            if (link.getAttribute('target') === '_blank') {
              window.open(url, '_blank');
            } else {
              window.location = url;
            }
          }
        }
      });

      document.addEventListener('mouseover', (e) => {
        if (e.target === document) return;
        if (e.target.matches('.js-clickable') || e.target.closest('.js-clickable')) {
          const el = e.target.matches('.js-clickable') ? e.target : e.target.closest('.js-clickable');
          helpers.addClass(el, 'hover');
        }
      });

      document.addEventListener('mouseout', (e) => {
        if (e.target === document) return;
        if (e.target.matches('.js-clickable') || e.target.closest('.js-clickable')) {
          const el = e.target.matches('.js-clickable') ? e.target : e.target.closest('.js-clickable');
          helpers.removeClass(el, 'hover');
        }
      });
    },
  };
}());
